export function formatCivilDate(value) {
  if (value == null || value === '') return '—';
  const text = value instanceof Date ? value.toISOString() : String(value);
  const match = text.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!match) return '—';
  return `${match[3]}/${match[2]}/${match[1]}`;
}

export function formatChartDay(value) {
  const civil = formatCivilDate(value);
  if (civil === '—') return civil;
  return civil.slice(0, 5);
}

export function formatReportDateTime(value) {
  if (value == null || value === '') return '—';
  const text = value instanceof Date ? value.toISOString() : String(value);
  const wall = text.match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})/);
  if (wall && !text.endsWith('Z') && !/[+-]\d{2}:\d{2}$/.test(text)) {
    return `${wall[3]}/${wall[2]}/${wall[1]}, ${wall[4]}:${wall[5]}`;
  }
  const date = new Date(text);
  if (Number.isNaN(date.getTime())) return text;
  return new Intl.DateTimeFormat('pt-BR', {
    timeZone: 'America/Sao_Paulo',
    dateStyle: 'short',
    timeStyle: 'short',
    hourCycle: 'h23',
  }).format(date);
}
